export default __webpack_public_path__ + "images/ZH.ffecc92.png";